import { ModelSagres } from "@/types/model-sagres";

export class FiltrosManifestacoes extends ModelSagres {
  filtroAssunto: number | null
  filtroUsuario: string
  filtroStatus: number | null
  dataCriacaoInicio: Date | undefined
  dataCriacaoFim: Date | undefined
  filtroMsg: string
  filtroNumero: number | null
  filtroAno: number | null

  constructor(obj?: any) {
    super()
    if (obj) {
      if (obj.filtroAssunto) this.filtroAssunto = obj.filtroAssunto
      if (obj.filtroUsuario) this.filtroUsuario = obj.filtroUsuario
      if (obj.filtroStatus) this.filtroStatus = obj.filtroStatus
      if (obj.dataCriacaoInicio) this.dataCriacaoInicio = obj.dataCriacaoInicio
      if (obj.dataCriacaoFim) this.dataCriacaoFim = obj.dataCriacaoFim
      if (obj.filtroMsg) this.filtroMsg = obj.filtroMsg
      if (obj.filtroNumero) this.filtroNumero = obj.filtroNumero
      if (obj.filtroAno) this.filtroAno = obj.filtroAno
    }
  }

  limpar(): void {
    this.filtroAssunto = null
    this.filtroUsuario = ''
    this.filtroStatus = null
    this.dataCriacaoInicio = undefined
    this.dataCriacaoFim = undefined
    this.filtroMsg = ''
    this.filtroNumero = null
    this.filtroAno = null
  }
}
